import React from 'react';
import PropTypes from 'prop-types';
import { matchPath } from 'react-router';
import useReactRouter from 'use-react-router';
import MenuItem from './MenuItem';

const NavMenuItem = ({
  className,
  path,
  exact,
  strict,
  onClick: handleOnClick,
  ...props
}) => {
  const { history, location } = useReactRouter();
  const onClick = event => {
    history.push(path);
    if (handleOnClick) {
      return handleOnClick(event);
    }
    return true;
  };
  const active = matchPath(location.pathname, {
    path,
    exact,
    strict,
  });

  return (
    <MenuItem
      className={[className, active ? 'active' : false]
        .filter(Boolean)
        .join(' ')}
      active={active}
      onClick={onClick}
      {...props}
    />
  );
};

NavMenuItem.propTypes = {
  className: PropTypes.string,
  path: PropTypes.string.isRequired,
  exact: PropTypes.bool,
  strict: PropTypes.bool,
  onClick: PropTypes.func,
};

NavMenuItem.defaultProps = {
  className: null,
  exact: false,
  strict: false,
  onClick: null,
};

export default NavMenuItem;
